import $http from "@/services/Http";
import { prefix } from "@/api/config";
import { responseToClass } from "@/api/lib";
import Comment from "@/models/Comment";

export function list(datasetId: number | string) {
  return $http
    .get(`${prefix}/datasets/${datasetId}/comments`)
    .then((response) => responseToClass(Comment, response));
}

export function store(datasetId: string, data: number) {
  return $http
    .post(`${prefix}/datasets/${datasetId}/comments`, data)
    .then((response) => responseToClass(Comment, response));
}

export function remove(datasetId: string, commentId: string) {
  return $http.delete(`${prefix}/datasets/${datasetId}/comments/${commentId}`);
}
